import ZH from '../constants/zh.json';

const localeTextTranslationsZh = { ...ZH };

export default localeTextTranslationsZh;
